import React, { useRef, useState } from 'react';
import { Volume2, VolumeX, ChevronLeft, ChevronRight, Play, X } from 'lucide-react';
import { PRODUCT_VIDEOS } from '../mock';

const ProductVideos = ({ compact = false }) => {
  const [activeIdx, setActiveIdx] = useState(0);
  const [muted, setMuted] = useState(true);
  const [open, setOpen] = useState(false);
  const videoRefs = useRef([]);

  const toggleMute = () => {
    setMuted((m) => {
      const newMuted = !m;
      videoRefs.current.forEach((v) => {
        if (v) v.muted = newMuted;
      });
      return newMuted;
    });
  };

  const next = () => setActiveIdx((i) => (i + 1) % PRODUCT_VIDEOS.length);
  const prev = () => setActiveIdx((i) => (i - 1 + PRODUCT_VIDEOS.length) % PRODUCT_VIDEOS.length);

  return (
    <section className={compact ? 'mt-8' : 'mt-20'}>
      {!compact && (
        <>
          <h2 className="font-serif text-[30px] md:text-[40px] text-center mb-2" style={{ color: '#2D5A3D' }}>
            See it in action
          </h2>
          <p className="text-[14px] text-center mb-10 opacity-75" style={{ color: '#2C2418' }}>
            Real moments. Real ritual. 60 seconds that change everything.
          </p>
        </>
      )}

      <div className={compact ? 'grid grid-cols-3 gap-2 sm:gap-3' : 'grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-6'}>
        {PRODUCT_VIDEOS.map((v, idx) => (
          <button
            key={v.id}
            onClick={() => { setActiveIdx(idx); setOpen(true); }}
            className="group relative aspect-[9/16] rounded-2xl overflow-hidden bg-black"
          >
            <video
              ref={(el) => (videoRefs.current[idx] = el)}
              src={v.src}
              poster={v.poster}
              muted
              loop
              playsInline
              autoPlay
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors" />
            <div className={compact ? 'absolute inset-0 flex items-center justify-center' : 'absolute bottom-3 right-3'}>
              <div className={(compact ? 'w-12 h-12 border-2 border-white/95' : 'w-10 h-10 bg-white/85 backdrop-blur') + ' rounded-full flex items-center justify-center'}>
                <Play size={compact ? 18 : 18} fill={compact ? '#FFFFFF' : '#2D5A3D'} color={compact ? '#FFFFFF' : '#2D5A3D'} />
              </div>
            </div>
          </button>
        ))}
      </div>

      {/* Lightbox */}
      {open && (
        <div
          className="fixed inset-0 z-[110] flex items-center justify-center p-4"
          style={{ backgroundColor: 'rgba(0,0,0,0.92)' }}
          onClick={() => setOpen(false)}
        >
          <button
            onClick={(e) => { e.stopPropagation(); setOpen(false); }}
            className="absolute top-5 right-5 w-10 h-10 rounded-full bg-white/15 hover:bg-white/25 flex items-center justify-center text-white"
            aria-label="Close"
          >
            <X size={20} />
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); prev(); }}
            className="absolute left-3 md:left-8 w-11 h-11 rounded-full bg-white/15 hover:bg-white/25 flex items-center justify-center text-white"
            aria-label="Previous"
          >
            <ChevronLeft size={22} />
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); next(); }}
            className="absolute right-3 md:right-8 w-11 h-11 rounded-full bg-white/15 hover:bg-white/25 flex items-center justify-center text-white"
            aria-label="Next"
          >
            <ChevronRight size={22} />
          </button>
          <div className="relative w-full max-w-[420px] aspect-[9/16] rounded-lg overflow-hidden" onClick={(e) => e.stopPropagation()}>
            <video
              key={PRODUCT_VIDEOS[activeIdx].id}
              src={PRODUCT_VIDEOS[activeIdx].src}
              poster={PRODUCT_VIDEOS[activeIdx].poster}
              autoPlay
              loop
              muted={muted}
              playsInline
              controls={false}
              className="w-full h-full object-cover bg-black"
            />
            <button
              onClick={toggleMute}
              className="absolute bottom-4 right-4 w-10 h-10 rounded-full bg-white/85 backdrop-blur flex items-center justify-center"
              aria-label={muted ? 'Unmute' : 'Mute'}
            >
              {muted ? <VolumeX size={18} color="#2D5A3D" /> : <Volume2 size={18} color="#2D5A3D" />}
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default ProductVideos;
